import { createFileRoute } from '@tanstack/react-router'
import ErrorComponent from '@/features/errors/error-component'
import { zodValidator } from '@tanstack/zod-adapter'
import Index from '@/features/scenic/scenic-areas/pages'
import { searchQueryOptions } from '@/features/scenic/scenic-areas/query-options'
import { SearchSchema } from '@/features/scenic/scenic-areas/schemas/search'

export const Route = createFileRoute('/_authenticated/(scenic)/scenic-areas/')({
  component: Index,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      searchQueryOptions({ key: 'scenic-areas', search: deps })
    )
  },
  errorComponent: ({ error }) => {
    return <ErrorComponent error={error} />
  },
})
